<template>
  <a-dialog
    ref="adialog"
    v-model="showDialog"
    :title="title"
    :toolbar="toolbar"
    :dialog-width="width"
    @input="closeDialog"
  >
    <div class="selector_search">
      <el-form
        :inline="true"
        label-width="100px"
        class="search_form"
        @submit.native.prevent
      >
        <el-form-item
          v-for="(item, index) in search"
          :key="index"
          :label="item.label"
          :prop="item.key"
        >
          <!-- 实现页面传过来的固定参数回显到选择器的搜索栏中,同时需要加v-if在组件 -->
          <el-select
            v-if="item.slectKey || item.selectApi"
            v-model="item.disabled ? params[item.key] : query[item.key]"
            :disabled="item.disabled"
            placeholder="请选择"
            style="width:160px;"
          >
            <el-option
              v-for="itm in getSelectOption(item)"
              :key="itm[defaultOption.value]"
              :label="itm[defaultOption.label]"
              :value="itm[defaultOption.value]"
            />
          </el-select>
          <el-input
            v-else
            v-model="item.disabled ? params[item.key] : query[item.key]"
            :disabled="item.disabled"
            style="width:160px;"
          />
        </el-form-item>
      </el-form>
      <div class="search_btn">
        <el-button size="mini" type="primary" @click="searchFuc">查询</el-button>
        <el-button size="mini" type="info" plain @click="resetFuc">重置</el-button>
      </div>
    </div>
    <el-table
      ref="selectTable"
      v-loading="tableLoading"
      class="page-table-info"
      height="380"
      highlight-current-row
      :data="tableData"
      stripe
      :row-key="functionRowkey"
      @selection-change="handleSelectionChange"
      @row-click="handleClick"
    >
      <el-table-column v-if="!multiple" align="center" width="50">
        <template slot-scope="scope">
          <el-radio
            v-model="currentRow"
            class="position-map-radio"
            :label="scope.row"
            @click.native="choosCurrentRow(scope.row)"
          >
            <i />
          </el-radio>
        </template>
      </el-table-column>
      <el-table-column v-if="multiple" :reserve-selection="reserveSelection" align="center" type="selection" width="50" />
      <el-table-column
        v-for="(itm,idx) in column"
        :key="idx"
        :prop="itm.prop"
        :label="itm.label"
        :align="itm.align"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="itm.slectKey">{{ dict.label[itm.slectKey][scope.row[itm.prop]] }}</span>
<!--					<template v-else-if="sign === 'selectUser' && itm.prop === 'roleNames'">
						<span v-if="scope.row.admin || scope.row.sysGen"> 系统管理员 </span>
						<span v-else-if="scope.row.entAdmin === '1'"> 管理员 </span>
						<span v-else-if="scope.row.entAdmin === '2'"> 操作员 </span>
					</template>-->
          <span v-else>{{ scope.row[itm.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align:right;margin-top:6px;"
      :current-page.sync="pageObj.page"
      :page-size="pageObj.size"
      layout="total, prev, pager, next, sizes,jumper"
      :total="pageObj.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </a-dialog>
</template>

<script>
import request from '@/utils/request'
import setData from './setting.js'
export default {
  name: 'Selector',
  props: {
    // 双向绑定
    value: {
      type: Boolean,
      default: false
    },
    // 选择器的标识
    sign: {
      type: String,
      required: true
    },
    // radio-单选 multiple-多选
    multiple: {
      type: Boolean,
      default: false
    },
    // 是否跨页多选
    reserveSelection: {
      type: Boolean,
      default: true
    },
    // 查询固定参数
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    width: {
      type: String,
      default: '820px'
    },
    //初始化查询
    initQuery: {
      type: Boolean,
      default: true
    },
  },
  dicts: ['MENU_TYPE', 'HAVE_PLAN'],
  data() {
    return {
      defaultOption: {
        value: 'value',
        label: 'label'
      },
      currentRow: null,
      pageObj: {
        page: 1,
        size: 10,
        total: 0
      },
      formData: this.value,
      query: {}, // 查询条件
      _selectData: [], // 预选数据
      selectData: [], // 选择的数据
      tableData: [], // 查询表格数据
      title: setData[this.sign].title, // 选择器标题
      search: setData[this.sign].search, // 选择器搜索条件
      column: setData[this.sign].column, // 选择器表格配置
      api: setData[this.sign].api, // 接口
      idKey: setData[this.sign].id, // 行唯一标识
      selectColumn: setData[this.sign].column.slice(0, 1),
      showDialog: this.value,
      toolbar: [
        {
          text: '取消',
          type: 'plain',
          func: (done) => {
            done()
          },
          hide: !this.multiple
        }, {
          text: '确认',
          func: (done) => {
            this.confirmData(done)
          },
          hide: !this.multiple
        }
      ],
      tableLoading: false
    }
  },
  watch: {
    value(val) {
      this.showDialog = val
      if(val){
        this.initData()
      }
    }
  },
  created() {
   /* if (this.initQuery) {
      this.initData()
    }*/
    // 选择器下拉需要调用接口
    this.initSelect()
  },
  methods: {
    // 表格单击事件
    handleClick(row) {
      if (!this.multiple) {
        this._selectData = []
        this._selectData.push(row)
        this.$emit('selectData', this._selectData)
        this.$refs.adialog.done()
      }else{
        this.$refs.selectTable.toggleRowSelection(row)
      }
    },
    initData() {
      this.tableLoading = true
      request({
        url: this.api,
        method: 'get',
        params: Object.assign({
          page: this.pageObj.page,
          size: this.pageObj.size
        }, this.query, this.params)
      }).then(res => {
        // 重置单选状态
        this.currentRow = null
        this.tableLoading = false
        this.tableData = res.records
        this.pageObj.total = res.totalCount
      }).catch(err => {
        this.tableLoading = false
        console.error(err)
      })
    },
    handleSizeChange(val){
      this.pageObj.size = val
      this.pageObj.page = 1
      this.initData()
    },
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.initData()
    },
    // 单选
    choosCurrentRow(val) {
      this._selectData = []
      this._selectData.push(val)
      this.$emit('selectData', this._selectData)
      this.$refs.adialog.done()
    },
    // 多选
    handleSelectionChange(val) {
      this._selectData = val
    },
    confirmData(done) {
      this.$emit('selectData', this._selectData)
      done()
    },
    closeDialog() {
      this.$emit('input', false)
    },
    searchFuc() {
      this.pageObj.page = 1
      this.resetSelector()
    },
    resetFuc() {
      for (const key in this.query) {
        this.query[key] = ''
      }
      this.pageObj.page = 1
      this.resetSelector()
    },
    resetSelector() {
      this.initData()
      // 重置时，清空已选的数据
      this._selectData = []
      // 清除表格多选
      this.$refs.selectTable.clearSelection()
    },
    functionRowkey(row) {
      return row[this.idKey]
    },
    initSelect() {
      this.search.forEach(item => {
        if (item.defaultOption) {
          this.defaultOption = item.defaultOption
        }
        if (item.selectApi) {
          request({ url: item.selectApi, method: 'get' }).then(res => {
            this.$set(item, 'list', res)
          }).catch(err => {
            console.error(err)
          })
        }
      })
    },
    getSelectOption(item) {
      let optionArr = []
      if (item.selectApi) {
        optionArr = item.list
      } else if (item.slectKey) {
        optionArr = this.dict[item.slectKey]
      }
      return optionArr
    }
  }
}
</script>

<style lang="scss">
.selector_search {
  display: flex;
  justify-content: flex-start;
  .search_form {
    flex: 3;
  }
  .search_btn {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
</style>
